/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Andrew Merrill <andrew.merrill@deliciousai.com>
 */

import { tolgee } from './tolgee'

export const useApiLanguage = () => {
  const currentLanguage = tolgee.getLanguage() || 'en'

  const getLanguageHeaders = () => ({
    'Accept-Language': currentLanguage,
  })

  const addLanguageToParams = (params: Record<string, any>) => ({
    ...params,
    language: currentLanguage,
  })

  return {
    currentLanguage,
    getLanguageHeaders,
    addLanguageToParams,
  }
}
